/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import uuid from 'uuid4';
import { getLocalStorage, setLocalStorage } from './localStorageAccess';

function getMachineId(): string {
  const key = 'machineId';
  const id = getLocalStorage(key) || uuid();
  setLocalStorage(key, id);

  return id;
}

export const machine = {
  id: getMachineId(),
};
